import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { FeatureAccessService } from '../Services/feature-access.service';

@Injectable({
  providedIn: 'root'
})
export class NonProjectFeatureAccessGuard implements CanActivate {
  constructor(private svc: FeatureAccessService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const featureCode = route.data['nonProjectFeature'] as string;
    if (!featureCode) return true;

    return this.svc.nonProjectAccessMap.pipe(
      filter(accessMap => accessMap !== null),
      take(1),
      map(() => {
        if (this.svc.isNonProjectPageAllowed(featureCode)) {
          return true;
        }

        // DISABLED or HIDDEN - prevent route activation and redirect to access-required
        this.router.navigate(['/access-required']);
        return false;
      })
    );
  }
}
